import * as Sentry from "@sentry/react";

const PRODUCTION_HOSTNAMES = ["trackbook.com", "www.trackbook.com"];

// Only the deployed site reports errors - not the dev server or local builds (they run on a port,
// e.g. trackbook.com:3000 or localhost:4173) and not the GitLab Pages build of the develop branch
const isSentryEnabled =
  PRODUCTION_HOSTNAMES.includes(window.location.hostname) &&
  window.location.port === "";

Sentry.init({
  dsn: isSentryEnabled
    ? "https://3dc0a742deb030e11a480a22e4d419e3@o4508218204749824.ingest.de.sentry.io/4508218206715984"
    : undefined,
  // Request headers and user IP are collected by default (Sentry SDK v11 `dataCollection` defaults,
  // the same as `sendDefaultPii: true` in v10), for more info visit:
  // https://docs.sentry.io/platforms/javascript/configuration/options/#dataCollection
  // Replay integration is added after page load, see below
  integrations: [Sentry.browserTracingIntegration()],
  // Tracing every page load adds overhead to all users (spans for every request and resource),
  // a 10% sample is enough to get representative performance data
  tracesSampleRate: 0.1,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/trackbook\.com/],
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// Session Replay is large, so it's loaded from Sentry's CDN only after the page has loaded
// instead of being part of the main bundle and slowing down the initial render
if (isSentryEnabled) {
  window.addEventListener("load", () => {
    Sentry.lazyLoadIntegration("replayIntegration")
      .then((replayIntegration) => Sentry.addIntegration(replayIntegration()))
      .catch(() => {
        // Loading can fail, e.g. when blocked by an ad blocker - the app works without it
      });
  });
}
